// カスタムバリアントセレクターの初期化
(function() {
  // DOMContentLoadedイベントで初期化
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      initCustomVariantSelectors();
    }, 100);
  });

  // Shopifyのセクション読み込みイベントにも対応
  if (typeof Shopify !== 'undefined' && Shopify.theme && typeof Shopify.theme.on === 'function') {
    Shopify.theme.on('section:load', function() {
      setTimeout(function() {
        initCustomVariantSelectors();
      }, 100);
    });
  } else {
    // Shopify.theme.onが利用できない場合の代替処理
    // セクション更新を検知する代替手段（MutationObserverを使用）
    const sectionObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setTimeout(function() {
            initCustomVariantSelectors();
          }, 100);
        }
      });
    });

    // 監視開始（body要素の変更を監視）
    document.addEventListener('DOMContentLoaded', function() {
      sectionObserver.observe(document.body, { childList: true, subtree: true });
    });
  }

  // ページ読み込み完了時にも初期化
  window.addEventListener('load', function() {
    setTimeout(function() {
      initCustomVariantSelectors();
    }, 100);
  });

  // フォーム送信前にバリアントIDを検証
  document.addEventListener('DOMContentLoaded', function() {
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    addToCartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const variantIdInput = form.querySelector('input[name="id"]');
        if (variantIdInput) {
          const variantId = variantIdInput.value;

          // バリアントIDが空または不正な値の場合、警告を表示
          if (!variantId || variantId === 'undefined' || variantId === 'null') {
            // フォーム送信を中止する場合はコメントを外す
            // e.preventDefault();
            // alert('商品のバリエーションを選択してください');
          }
        }
      });
    });
  });

  /**
   * カスタムバリアントセレクターを初期化する
   */
  function initCustomVariantSelectors() {
    // product-options__sectionのselect要素も対象にする
    const productOptionSelects = document.querySelectorAll('.product-options__section[data-style="select"]');
    productOptionSelects.forEach(function(select) {
      const parent = select.closest('.select');
      if (parent && !parent.querySelector('[data-variant-selector]')) {
        // 既にカスタムセレクターが適用されていない場合のみ処理
        wrapSelectWithCustomSelector(select, parent);
      }
    });

    // 既存のカスタムセレクターを初期化
    const selectors = document.querySelectorAll('[data-variant-selector]');

    selectors.forEach(function(selector) {
      // 既に初期化済みの場合はスキップ
      if (selector.classList.contains('initialized')) {
        return;
      }

      const selectedDisplay = selector.querySelector('[data-selected-display]');
      const options = selector.querySelectorAll('.custom-variant-selector__option');
      const select = selector.querySelector('select');

      if (!selectedDisplay || !options.length || !select) {
        return;
      }

      // クリックでドロップダウンを開閉
      selectedDisplay.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown(selector);
      });

      // オプション選択
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.stopPropagation();

          if (option.classList.contains('disabled')) return;

          const value = option.getAttribute('data-value');
          const title = option.getAttribute('data-title');

          // 選択状態を更新
          options.forEach(opt => opt.classList.remove('selected'));
          option.classList.add('selected');

          // 表示テキストを更新
          const textElement = selectedDisplay.querySelector('.custom-variant-selector__text');
          if (textElement) {
            textElement.textContent = title;
          }

          // セレクトボックスの値を更新
          if (select) {
            select.value = value;

            // 変更イベントを発火
            const event = new Event('change', { bubbles: true });
            select.dispatchEvent(event);

            // フォーム内のhidden input[name="id"]も更新
            const form = select.closest('form');
            if (form) {
              const hiddenInput = form.querySelector('input[name="id"]');
              if (hiddenInput) {
                hiddenInput.value = value;
              }
            } else {
              // フォームが見つからない場合、ページ内のすべてのinput[name="id"]を探す
              const allHiddenInputs = document.querySelectorAll('input[name="id"]');
              if (allHiddenInputs.length > 0) {
                allHiddenInputs.forEach(function(input) {
                  input.value = value;
                });
              }
            }
          }

          // ドロップダウンを閉じる
          closeDropdown(selector);
        });
      });

      // 初期化済みとしてマーク
      selector.classList.add('initialized');
    });

    // ドキュメントクリックでドロップダウンを閉じる
    document.addEventListener('click', function() {
      closeAllDropdowns();
    });
  }

  /**
   * select要素をカスタムセレクターでラップする
   * @param {HTMLElement} select - select要素
   * @param {HTMLElement} parent - 親要素
   */
  function wrapSelectWithCustomSelector(select, parent) {
    // 既存のselect要素の情報を取得
    const options = Array.from(select.querySelectorAll('option'));
    const selectedOption = select.querySelector('option:checked') || options[0];

    // カスタムセレクター要素を作成
    const customSelector = document.createElement('div');
    customSelector.className = 'custom-variant-selector';
    customSelector.setAttribute('data-variant-selector', '');

    // 選択表示部分を作成
    const selectedDisplay = document.createElement('div');
    selectedDisplay.className = 'custom-variant-selector__selected';
    selectedDisplay.setAttribute('data-selected-display', '');

    const selectedText = document.createElement('span');
    selectedText.className = 'custom-variant-selector__text';
    selectedText.textContent = selectedOption ? selectedOption.textContent : '';

    const arrow = document.createElement('span');
    arrow.className = 'custom-variant-selector__arrow';

    selectedDisplay.appendChild(selectedText);
    selectedDisplay.appendChild(arrow);

    // オプション部分を作成
    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'custom-variant-selector__options';

    options.forEach(function(option) {
      if (option.disabled && option.selected) return; // 無効な選択肢はスキップ

      const optionElement = document.createElement('div');
      optionElement.className = 'custom-variant-selector__option';
      if (option.selected) optionElement.classList.add('selected');
      if (option.disabled) optionElement.classList.add('disabled');

      optionElement.setAttribute('data-value', option.value);
      optionElement.setAttribute('data-title', option.textContent);
      optionElement.textContent = option.textContent;

      optionsContainer.appendChild(optionElement);
    });

    // 元のselect要素のクラスを追加
    select.classList.add('custom-dropdown-original');

    // 要素を組み立てる
    customSelector.appendChild(selectedDisplay);
    customSelector.appendChild(optionsContainer);
    customSelector.appendChild(select.cloneNode(true)); // select要素のコピーを追加

    // 親要素に挿入
    parent.insertBefore(customSelector, select);
    select.style.display = 'none'; // 元のselect要素を非表示に
  }

  /**
   * ドロップダウンを開閉する
   * @param {HTMLElement} selector - セレクター要素
   */
  function toggleDropdown(selector) {
    const isOpen = selector.classList.contains('open');

    // 他のすべてのドロップダウンを閉じる
    closeAllDropdowns();

    // このドロップダウンが閉じていた場合は開く
    if (!isOpen) {
      selector.classList.add('open');
    }
  }

  /**
   * ドロップダウンを閉じる
   * @param {HTMLElement} selector - セレクター要素
   */
  function closeDropdown(selector) {
    selector.classList.remove('open');
  }

  /**
   * すべてのドロップダウンを閉じる
   */
  function closeAllDropdowns() {
    const openSelectors = document.querySelectorAll('.custom-variant-selector.open');
    openSelectors.forEach(function(selector) {
      closeDropdown(selector);
    });
  }
})();
